import React from "react";
import { FastField } from "formik";
import get from "lodash.get";

export default class FormInput extends React.PureComponent {
  render() {
    const {
      children,
      className,
      component,
      disabled,
      readOnly,
      errors,
      label,
      labelClassNames,
      name,
      touched,
      type,
      validate,
      style,
      ...props
    } = this.props;
    const error = get(errors, name) && get(touched, name);
    const errorText = get(errors, name);
    return (
      <React.Fragment>
        {label && (
          <label
            className={`line-height-double ${
              labelClassNames ? labelClassNames : "accent-text small-text"
            } ${className === "form-required" ? "form-required" : ""} ${
              error ? "error" : ""
            }`}
          >
            {label}
          </label>
        )}
        <FastField
          name={name}
          className={`custom-input ${error ? "error" : ""} ${
            className ? className : ""
          }`}
          component={component}
          type={type}
          validate={validate}
          {...props}
          disabled={disabled}
          readOnly={readOnly}
        >
          {children ? children : null}
        </FastField>
        {error && <p className="error-message">{errorText}</p>}
      </React.Fragment>
    );
  }
}
